import { Button, Dialog, Icon } from '@risksmart-app/atomic-ui';
import { Trans, useTranslation } from 'react-i18next';

interface DiscardDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDiscard: () => void;
}

export const DiscardDialog = ({
  open,
  onOpenChange,
  onDiscard,
}: DiscardDialogProps) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'riskScoringSettings',
  });

  return (
    <Dialog open={open} onOpenChange={onOpenChange} size={'md'}>
      <Dialog.Header title={t('discard.dialogTitle')} />
      <Dialog.Body>
        <Trans
          i18nKey={'riskScoringSettings.discard.dialogBody'}
          ns={'common'}
          components={{ bold: <span className={'font-bold'} /> }}
        />
      </Dialog.Body>
      <Dialog.Footer>
        <Dialog.Close
          render={
            <Button>
              <Icon name={'pencil-01'} />
              {t('discard.keepEditing')}
            </Button>
          }
        />
        <Button onClick={onDiscard} variant={'neutral'} style={'outline'}>
          {t('discard.confirmButton')}
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
};
